import { TextAreaField, TextAreaFieldProps } from './TextAreaField';

export type { TextAreaFieldProps };
export default TextAreaField;
